import { getAuthHeaders } from '../utils/authHeaders';
import { createFormPdf } from '../utils/formPdf';

const API_URL = 'https://app.pvslimited.co.uk/api';

const CALIBRATION_STEPS = [
  { field: 'reading5mm', label: '5mm' },
  { field: 'reading10mm', label: '10mm' },
  { field: 'reading15mm', label: '15mm' },
  { field: 'reading20mm', label: '20mm' },
  { field: 'reading25mm', label: '25mm' },
];

const formatDateForSubject = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(d.getTime())) return dateStr;
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

const sendUltrasonicDailyCheckEmail = async (formData) => {
  try {
    const blob = await createFormPdf({
      title: 'ULTRASONIC DAILY CALIBRATION CHECK',
      ref: 'Ref: PVS-UDC-001 | Version: 2.0',
    }, (pdf) => {
      pdf.field('Name', formData.inspectorName);
      pdf.field('Date', formatDateForSubject(formData.date));

      pdf.section('CALIBRATION BLOCK READINGS');
      pdf.table(
        CALIBRATION_STEPS.map((step) => step.label),
        [CALIBRATION_STEPS.map((step) => (formData[step.field] ? `${formData[step.field]} mm` : 'N/A'))]
      );

      pdf.section('DAILY CHECKS');
      pdf.check(
        'The Machine is free from damage that may have an impact on its readings validity?',
        formData.machineFreeFromDamage
      );
      pdf.check(
        'The Machine battery is free from any dents/cracks or corrosion?',
        formData.batteryFreeFromDamage
      );
      pdf.check(
        'The Machine has been calibrated against the UKAS calibrated step block and is within 0.1mm of every step measurement?',
        formData.calibratedWithinTolerance
      );
    });

    const formattedDate = formatDateForSubject(formData.date);
    const subject = `${formData.inspectorName} ${formattedDate} Ultrasonic daily calibration check`;
    const safeName = String(formData.inspectorName || 'inspector').replace(/\s+/g, '_');

    const formDataToSend = new FormData();
    formDataToSend.append(
      'file',
      blob,
      `Ultrasonic_Daily_Check_${safeName}_${formData.date}_${Date.now()}.pdf`
    );
    formDataToSend.append('inspectorName', formData.inspectorName);
    formDataToSend.append('date', formData.date);
    formDataToSend.append('subject', subject);
    formDataToSend.append('machineFreeFromDamage', formData.machineFreeFromDamage);
    formDataToSend.append('batteryFreeFromDamage', formData.batteryFreeFromDamage);
    formDataToSend.append('calibratedWithinTolerance', formData.calibratedWithinTolerance);
    CALIBRATION_STEPS.forEach((step) => {
      formDataToSend.append(step.field, formData[step.field] ?? '');
    });
    formDataToSend.append('formType', 'ultrasonic-daily-check');

    const response = await fetch(`${API_URL}/send-ultrasonic-daily-check-email`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: formDataToSend,
    });

    if (!response.ok) {
      const errorText = await response.text();
      let message = 'Failed to submit ultrasonic daily check.';
      try {
        const payload = JSON.parse(errorText);
        if (payload?.error) message = payload.error;
      } catch {
        if (errorText) message = errorText;
      }
      throw new Error(message);
    }

    return response.json();
  } catch (error) {
    console.error('Error in sendUltrasonicDailyCheckEmail:', error);
    throw error;
  }
};

export default sendUltrasonicDailyCheckEmail;
